import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import apis from '../services';
import Header from './Header';
import DynamicHeader from '../Header/DynamicHeader';

const DetailView = ({ showHeader = true }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [tokenData, setTokenData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [hasMoreData, setHasMoreData] = useState(true); 
  const navigate = useNavigate();
  const pageSize = 50; 

  const fetchTokenData = async (page) => {
    setLoading(true);
    try {
      const response = await apis.alltoken({ page, page_size: pageSize }); 
      const { tokenDetails, totalPages: apiTotalPages } = response;

      const formattedData = tokenDetails.map((token) => ({
        name: token.CoinName || token.name, 
        price: token.price,
        age: token.age,
        txn: token.totalTransactions,
        fiveMin: token.pricePercentage.m5,
        oneHr: token.pricePercentage.h1,
        sixHr: token.pricePercentage.h6,
        twentyFourHr: token.pricePercentage.h24,
        vol: token.volume,
        liq: token.liquidity,
        mcap: token.Mcap,
        fdv: token.fdv,
        tokenAddress: token.tokenAddress,
        chainName: token.chainName, 
      }));

      setTokenData((prevData) => [...prevData, ...formattedData]); 
      setTotalPages(apiTotalPages); 
      if (tokenDetails.length < pageSize) {
        setHasMoreData(false); 
      }
    } catch (err) {
      console.error('Error fetching token data:', err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTokenData(currentPage); 
    // eslint-disable-next-line
  }, [currentPage]);

  const handleCellClick = (e, row) => {
    if (row.chainName && row.chainName.toLowerCase() === 'solana') {
      return;
    }

    if (e.target.classList.contains('coin-name-cell')) {
      navigate(`/details/${row.tokenAddress}`, { state: { tokenAddress: row.tokenAddress } });
    } else if (e.target.classList.contains('price-cell')) {
      navigate(`/price/${row.tokenAddress}`, { state: { tokenAddress: row.tokenAddress } });
    }
  };

 
  const handleShowMore = () => {
    if (hasMoreData && !loading) {
      setCurrentPage((prevPage) => prevPage + 1); 
    }
  };

  return (
    <>
      <div className="newpool-back">
       <DynamicHeader/>
        {/* {showHeader && <Header showHeader={showHeader} />} */}
<div style={{marginTop : "10px"}}></div>
      
        {loading ? (
          <div className="table-container-new custom-scrollbar">
            <table className="table-table-container">
              <thead className="active-header">
                <tr>
                  <th>Coin Name</th>
                  <th>Price</th>
                  <th>Age</th>
                  <th>TXN</th>
                  <th>5M</th>
                  <th>1H</th>
                  <th>6H</th>
                  <th>24H</th>
                  <th>VOL</th>
                  <th>LIQ</th>
                  <th>MCAP</th>
                  <th>FDV</th>
                </tr>
              </thead>
              <tbody>
                {Array.from({ length: 15 }).map((_, index) => (
                  <tr key={index}>
                    {Array.from({ length: 12 }).map((_, cellIndex) => (
                      <td key={cellIndex}>
                        <div className="skeleton skeleton-text"></div>
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="table-container-new custom-scrollbar">
            <table className="table-table-container">
              <thead className="active-header">
                <tr>
                  <th>Coin Name</th>
                  <th>Price</th>
                  <th>Age</th>
                  <th>TXN</th>
                  <th>5M</th>
                  <th>1H</th>
                  <th>6H</th>
                  <th>24H</th>
                  <th>VOL</th>
                  <th>LIQ</th>
                  <th>MCAP</th>
                  <th>FDV</th>
                </tr>
              </thead>
              <tbody>
                {tokenData.map((row, index) => (
                  <tr key={index}>
                    <td
                      className="coin-name-cell"
                      onClick={(e) => handleCellClick(e, row)}
                      style={{ cursor: 'pointer' }}
                    >
                      {row.name}
                    </td>
                    <td className="price-cell">${row.price}</td>
                    <td>{row.age}</td>
                    <td>{row.txn}</td>
                    <td
                      className={row.fiveMin < 0 ? "negative" : "positive"}
                      style={{ color: row.fiveMin < 0 ? "red" : "green" }}
                    >
                      {row.fiveMin}
                    </td>
                    <td
                      className={row.oneHr < 0 ? "negative" : "positive"}
                      style={{ color: row.oneHr < 0 ? "red" : "green" }}
                    >
                      {row.oneHr}
                    </td>
                    <td
                      className={row.sixHr < 0 ? "negative" : "positive"}
                      style={{ color: row.sixHr < 0 ? "red" : "green" }}
                    >
                      {row.sixHr}
                    </td>
                    <td
                      className={row.twentyFourHr < 0 ? "negative" : "positive"}
                      style={{ color: row.twentyFourHr < 0 ? "red" : "green" }}
                    >
                      {row.twentyFourHr}
                    </td>
                    <td>${row.vol}</td>
                    <td>${row.liq}</td>
                    <td>${row.mcap}</td>
                    <td>${row.fdv}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {hasMoreData && (
          <div className="show-more-container">
            <button onClick={handleShowMore} disabled={loading}>
              {loading ? 'Loading...' : 'Show More'}
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default DetailView;
